/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultPhoneCompany } from '../../models/api-response-paged-result-phone-company';
import { PagedRequestPhoneCompany } from '../../models/paged-request-phone-company';

export interface SearchPhoneCompany$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestPhoneCompany
}

export function searchPhoneCompany(http: HttpClient, rootUrl: string, params: SearchPhoneCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultPhoneCompany>> {
  const rb = new RequestBuilder(rootUrl, searchPhoneCompany.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultPhoneCompany>;
    })
  );
}

searchPhoneCompany.PATH = '/v1/api/admin-ui/company/search-phone';
